export default __webpack_public_path__ + "static/media/mariog11.57a5fcd4.jpg";